import type { OrganisationModuleByOrgIdResponse } from '@risksmart-app/trpc/types/backend/v1/organisation-module.types';
import type { GetModulesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetModulesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetModules = createQueryHook<
  Record<string, never>,
  OrganisationModuleByOrgIdResponse | null,
  GetModulesQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.organisationModule.getByOrgId.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    organisation_module: data?.organisationModule
      ? [data.organisationModule]
      : [],
  }),
  graphqlDocument: GetModulesDocument,
});
